import { render, staticRenderFns } from "./ActionsCard.htm?vue&type=template&id=70f7e3d4&scoped=true&"
import script from "./ActionsCard.ts?vue&type=script&lang=js&"
export * from "./ActionsCard.ts?vue&type=script&lang=js&"
import style0 from "./ActionsCard.scss?vue&type=style&index=0&id=70f7e3d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f7e3d4",
  null
  
)

export default component.exports